<template>
  <v-tooltip
    top
    v-bind="tooltipProps"
    v-bind:value="show">
    <template v-slot:activator="{ on }">
      <slot name="trigger" v-bind:listener-object="getListenerObject(on)" />
    </template>
    <slot />
  </v-tooltip>
</template>

<script>
export default {
  computed: {
    tooltipProps() {
      return {
        disabled: this.isDisabled,
        [this.position]: true,
      };
    },
  },
  data() {
    return {
      show: this.isShow,
    };
  },
  methods: {
    toggleTooltip() {
      this.show = !this.show;
      setTimeout(() => {
        this.show = false;
      }, 3000);
    },
    getListenerObject(on) {
      if (this.triggerType === 'click') {
        return {
          click: this.toggleTooltip,
        };
      }
      return {
        ...on,
      };
    },
  },
  props: {
    isDisabled: { default: false, type: Boolean },
    isShow: { default: false, type: Boolean },
    position: { required: true, type: String },
    triggerType: {
      type: String,
      default: 'hover',
    },
  },
  name: 'TheTooltip',
};
</script>

<style>
</style>
